export const en = {
  links: {
    home: "Home",
    mission: "Mission",
    services: "Services",
    contact: "Contact",
    privacy: "Privacy Policy",
    paymentPlans: "Payment Plans",
  },
  contact: {
    title: "Contact Information",
    findUs: "Find us",
    btnWhatsapp: "btn_whatsapp_en.png",
    Call: "Call 754.752.1888",
    SMS: "MSG 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "PLEASE NOTE: AFTER HOURS AND WEEKENDS - We are only available via text message at:",
  },
  img: {
    img1: "1_en2.jpg",
    img2: "2_en2.jpg",
  },
  footer: {
    quickLinks: "Quick Links",
    bookAppointment: "Book Appointment",
    footerDisclaimer: "Consultation required. Prescriptions are issued at the discretion of the medical provider based on clinical necessity. Results may vary by individual.",
  },
  altsImgs: {
    btnWhatsapp: "Start whatsapp chat button.",
    logoDiverse: "Diverse Care Now",
    slide1: "Slide 1",
    slide2: "Slide 2",
  },
  carousel: {
    previous: "Previous",
    next: "Next",
  },
  modal: {
    title: "Book an appointment",
    message: "Schedule your medical consultation today",
    close: "Close",
    bookNow: "Schedule Consultation",
  },
  weightLoss: {
    meta: {
      title: "Medical Weight Loss Program | Doctor-Supervised & Personalized Plans | Diverse Care Now",
    },
    header: {
      bookAppointment: "BOOK APPOINTMENT",
    },
    hero: {
      headline: "Doctor-Guided Weight Loss with Online Consultations and Comprehensive Clinical Support.",
      subtitle: "Our Medical Weight Loss Program is designed to provide safe, physician-supervised support for sustainable weight management.",
      description: "This medical weight loss program combines clinical evaluation, personalized planning, and metabolic health guidance to help patients achieve long-term results.",
    },
    features: {
      flexibleTitle: "Flexible Weight Management.",
      flexibleDesc: "Our clinical approach focuses on metabolic health to support your goals, adapting to your lifestyle and schedule.",
      emotionalTitle: "Support for Emotional Eating and Daily Challenges",
      emotionalDesc: "Get structured online coaching and clinical guidance to help manage dietary habits and maintain consistency.",
      licensedTitle: "Licensed Medical Expertise.",
      licensedDesc: "No trends. Just personalized treatment plans with certified professionals and expert prescription management.",
    },
    provider: {
      title: "Telehealth Specialist in Weight Loss & Longevity Care",
      subtitle: "Helping patients achieve lasting results through doctor-guided telemedicine and medical weight loss.",
      bio1: "As a board-certified physician in medical weight loss and longevity, I've helped thousands regain control — not just over weight, but over energy, mindset, and health.",
      bio2: "That's why I created Diverse Care Now: a telemedicine-based program focused on science, safety, and continuous medical care — with personalized care plans and ongoing clinical support. We utilize evidence-based metabolic treatments under strict medical guidance, plus nutrition coaching and remote follow-up — no clinic visits needed.",
      missionIntro: "My mission is simple:",
      missionText: "To help you achieve real results through medical support — not restriction, but smart, safe, doctor-led care.",
      bookConsultation: "Book Your Consultation",
    },
    stats: {
      count: "9.876+",
      patientsSupported: "Patients Supported",
      tagline: "Regain your confidence and shine",
      description: "Evidence-based, accessible care for your wellness journey.",
      proceduresPerformed: "Procedures Performed",
      proceduresDesc: "Effective, affordable procedure and lasting results.",
    },
    clinicalSupport: {
      title: "Comprehensive Clinical Support for Long-Term Metabolic Wellness",
      intro: "Evidence based clinical support focusing on metabolic health and balanced lifestyle habits.",
      body1: "Advanced, physician-guided weight management programs focus on supporting metabolic wellness and long-term health goals.",
      body2: "These programs are designed to support healthy routines and long-term wellness by addressing factors related to appetite awareness, digestion, and overall metabolic health.",
      focusIntro: "Program areas of focus include:",
      focus1: "Appetite awareness and eating patterns",
      focus2: "Portion control and digestive balance",
      focus3: "Consistent progress supported by healthy habits",
      closing1: "Under professional guidance, comprehensive care plans emphasize sustainable progress and consistency, always in combination with healthy habits.",
      closing2: "Our clinical programs prioritize sustainable metabolic health through professional guidance.",
    },
    pricing: {
      title: "Comprehensive Clinical Weight Support — Membership Plans Available",
      intro: "Personalized care and ongoing medical supervision, guided by licensed providers and focused on long-term health and balance.",
      body: "Our program begins with a clinical evaluation and continues with structured follow-up designed to support wellness and long-term health goals. Programs are medically guided and tailored to individual health profiles, lifestyle factors, and long-term wellness goals.",
      emphasis: "Metabolic health awareness, energy balance, and professional clinical support for long-term wellness. This is not a short-term solution. It's a medically supervised care model focused on long-term well-being.",
      basicTitle: "BASIC CARE PLAN – MEMBERSHIP OPTIONS",
      premiumTitle: "PREMIUM SUPPORT PLAN – MONTHLY CARE",
      disclaimer: "Dosage and medication details are determined after physician evaluation. For illustrative pricing only. Not a guarantee of treatment or amount.",
      premiumDisclaimer: "Dosage and medication type determined after physician consultation. For informational purposes only.",
      contraceptiveNote: "Some medical treatments may require additional considerations related to contraceptive use. Always follow guidance provided by your healthcare professional and manufacturer instructions.",
      contactSupport: "For clinical questions or follow-up care, please contact Diverse Care Now directly.",
    },
    careProcess: {
      step1Title: "Initial Consultation & Evaluation",
      step1Bullet1: "Comprehensive health history and metabolic review",
      step1Bullet2: "Personalized care plan aligned with your goals and health profile",
      step2Title: "Clinical Care Program",
      step2Bullet1: "Professional oversight and clinical monitoring",
      step2Bullet2: "Ongoing provider guidance as part of a supervised care model",
      step3Title: "Nutrition & Lifestyle Coaching",
      step3Bullet1: "Meal structure and portion awareness support",
      step3Bullet2: "Stress management and behavior-focused coaching",
      step4Title: "Check-ins & Ongoing Support",
      step4Bullet1: "Regular follow-ups via message or video",
      step4Bullet2: "Accountability and long-term care continuity",
      attribution: "Our program includes a clinical consultation and a structured physician-supervised care program guided by Laura Uchôa and her licensed medical team.",
    },
    nutrition: {
      label: "NUTRITIONAL GUIDANCE.",
      title: "THE FOUNDATION OF A STRUCTURED WELLNESS PROGRAM",
      subtitle: "Developed by Dr. Laura Uchôa and her team, this personalized nutrition framework is designed to support consistency, balance, and long-term wellness as part of a medically supervised care approach.",
      body: "At Diverse Care Now, nutrition guidance is provided as structured support within a comprehensive care program, aligned with individual preferences, routines, and overall health goals.",
      focus1: "Meal structure and balanced food choices",
      focus2: "Portion awareness and daily eating routines",
      focus3: "Personalized guidance aligned with wellness goals and activity levels",
      closing: "This is not a generic diet. It's a structured nutrition framework designed to support sustainable habits and long-term consistency within a medically supervised program.",
    },
    testimonials: {
      title: "PATIENT EXPERIENCES AND SHARED JOURNEYS",
      intro: "Our patients trust Diverse Care Now for personalized, physician-guided care and read about their personal experiences with our clinical care.",
      reviewCount: "791 verified Google reviews",
      reviewScope: "Covers weight management, aesthetic, and wellness programs",
      ratingNote: "Each rating reflects our ongoing commitment to medical quality, empathy, and real support",
      disclaimer: "Results may vary from person to person. Clinical outcomes depend on individual health profiles and adherence to the program",
      voicesTitle: "PATIENT VOICES. CLINICAL GUIDANCE. WELLNESS JOURNEYS",
      voicesBody: "Inside the clinic, Laura Uchôa and her team demonstrate how personalized, physician-guided care supports balance, confidence, and long-term health.",
      reviews: [
        { name: 'Samuel Carvalho', time: '5 months ago', text: 'This place provided me with the best aesthetic treatment. The staff is incredibly professional and welcoming.' },
        { name: 'Antonio Pinto', time: '3 months ago', text: 'Simply THE BEST PLACE FOR MEDICAL CARE. The entire staff is very attentive, from the counter staff to the doctors.' },
        { name: 'Flavio Braga', time: '6 months ago', text: 'Great first visit! Friendly staff, Dra. Laura Uchoa is very attentive and knowledgeable about everything.' },
        { name: 'Maria Santos', time: '2 months ago', text: 'Dr. Uchoa truly cares about her patients. The personalized approach to my weight loss journey has been life-changing.' },
        { name: 'John Davis', time: '4 months ago', text: 'Best telehealth experience I have ever had. The team is supportive and the nutrition guidance is practical.' },
        { name: 'Ana Paula', time: '1 month ago', text: 'I was skeptical about virtual weight loss programs, but Diverse Care Now exceeded all my expectations.' },
        { name: 'Carlos Mendes', time: '3 months ago', text: 'Professional service from start to finish. The medical team really listens and creates a plan that works.' },
        { name: 'Jennifer Lopez', time: '5 months ago', text: 'Amazing experience with the weight management program. Lost 25 lbs in 3 months with proper medical guidance.' },
      ],
    },
    comprehensiveApproach: {
      title: "A COMPREHENSIVE CLINICAL APPROACH FOCUSED ON YOUR WELL-BEING",
      subtitle: "Every plan begins with a comprehensive medical evaluation focused on metabolic health, overall balance, and long-term well-being.",
      body: "At Diverse Care Now, care is guided by licensed providers and tailored to your goals, lifestyle, and current health profile. Our programs integrate medical supervision, nutrition guidance, and activity planning — with ongoing support designed to adapt as your health needs evolve.",
      focus1: "Support for metabolic wellness and clinical balance",
      focus2: "Appetite awareness and eating patterns",
      focus3: "Energy balance and daily consistency",
      focus4: "Sustainable, long-term progress supported by healthy habits",
      keyMessage: "This is not a 'quick fix.' It's a medical partnership built around your health, your pace, and long-term well-being.",
      hipaa: "HIPAA-Compliant",
      boardCertified: "Board-Certified Provider",
      secure: "Secure & Confidential Submission",
    },
    clinicalOversight: {
      title: "PROFESSIONAL CLINICAL OVERSIGHT AND CONTINUOUS CARE",
      body: "At Diverse Care Now, clinical oversight is a fundamental part of our care model, providing structured professional guidance throughout your wellness journey. Follow-ups are structured to help providers review progress, address questions, and ensure care remains aligned with individual health needs. This approach emphasizes continuity, professional oversight, and clear communication throughout the care experience. Scheduled consultations are part of a clinically supervised program dedicated to supporting your long-term health and wellness goals.",
      credentialsTitle: "DEDICATED CLINICAL CARE AND PROFESSIONAL SUPPORT",
      credentialsSubtitle: "Our approach focuses on metabolic health and long-term wellness",
      cred1: "At Diverse Care Now, programs are tailored to support consistency and professional clinical guidance",
      cred2: "Under the guidance of Dr. Laura Uchôa, our team provides structured care designed to align with individual health profiles and evidence-based clinical practices",
      cred3: "Led by Dr. Laura Uchôa, our team provides structured, individualized care designed to support sustainable health goals with ongoing professional guidance and clear communication",
      cred4: "We prioritize evidence-based protocols and patient support, ensuring clear communication and professional oversight throughout your care experience",
    },
    enrollment: {
      cta1: "Start with a professional consultation and personalized evaluation",
      programsTitle: "COMPREHENSIVE CLINICAL WELLNESS PROGRAMS",
      body: "Every care plan begins with a comprehensive medical evaluation conducted by licensed providers. Treatment options, follow-up frequency, and care structure are determined individually based on your health profile, goals, and medical history. All care is supervised by Dr. Laura Uchôa and her licensed medical team, with ongoing monitoring to ensure safety, consistency, and long-term support. Specific treatment details, recommendations, and options are discussed only after a professional consultation.",
      cta2: "Start with a medical consultation to see if care is appropriate for you",
      consultHeadline: "Discuss whether medical care is appropriate for your health goals",
    },
    fourPillars: {
      title: "The 4 Medical Pillars Behind Lasting Weight Loss",
      subtitle: "A complete approach that blends clinical care, healthy habits, and continuous medical supervision",
      medicationTitle: "MEDICATION",
      medicationBody: "Supervised treatments help regulate appetite, improve metabolism, and support steady progress. When monitored by professionals, they remain one of the safest and most effective tools for long-term weight.",
      medicationLink: "Explore our blog to learn how physician-supervised therapies work safely under medical guidance",
      behaviorTitle: "Behavioral Changes",
      behaviorBody: "True change begins with daily consistency. Tracking meals, improving sleep quality, and managing stress all influence how the body responds to treatment and long-term health outcomes.",
      behaviorLink: "Explore our blog to discover how small habits create lasting results",
      activityTitle: "Physical Activity",
      activityBody: "Movement strengthens both body and mind. Even light, regular exercise improves energy, mood, and metabolism — supporting gradual, steady progress and better overall wellbeing.",
      activityLink: "Explore our blog for simple, safe ways to stay active every day",
      nutritionTitle: "Nutritional Therapy",
      nutritionBody: "Balanced nutrition is a core component of comprehensive care. Choosing nutrient-dense foods helps control hunger, stabilize blood sugar, and sustain long-term energy and health.",
      nutritionLink: "Explore our blog for healthy menus and evidence-based nutrition guides",
    },
    calculator: {
      title: "What Your Weight Doesn't Tell You, But Your Habits Do",
      subtitle: "Your weight is more than a number. Discover how your daily routine, metabolism, and activity level truly shape your body, and what that means for your personalized care plan.",
      sex: "Sex",
      male: "Male",
      female: "Female",
      age: "Age",
      years: "years",
      weight: "Weight",
      lbs: "lbs",
      heightFeet: "Height feet",
      ft: "ft",
      heightInches: "Height inches",
      in: "in",
      healthGoal: "Health Goal",
      maintainWeight: "Maintain Weight",
      cut250: "Cut (-250 kcal)",
      cut500: "Aggressive Cut (-500 kcal)",
      bulkSlow: "Slow Bulk (+200 kcal)",
      bulkLean: "Lean Bulk (+350 kcal)",
      activityLevel: "Activity Level",
      sedentary: "Sedentary",
      sedentaryDesc: "Little to no exercise (desk job)",
      light: "Light",
      lightDesc: "1–3 days/week light exercise",
      moderate: "Moderate",
      moderateDesc: "3–5 days/week moderate exercise",
      active: "Active",
      activeDesc: "6–7 days/week hard exercise",
      veryActive: "Very Active",
      veryActiveDesc: "Hard exercise & physical job",
      extraActive: "Extra Active",
      extraActiveDesc: "Athlete-level training or very physical work",
      advancedToggle: "Advanced: Estimate Body Fat % (U.S. Navy)",
      waist: "Waist",
      waistHint: "Measure at navel level (relaxed)",
      neck: "Neck",
      neckHint: "Below Adam's apple",
      hip: "Hip",
      hipHint: "Widest point of hips",
      advancedNote: "Body fat fields are optional. If left blank, body fat will not be estimated",
      calculate: "Calculate results",
      reset: "Reset all fields",
      resultsHeader: "YOUR RESULTS:",
      bmr: "Basal Metabolic Rate (BMR)",
      bmi: "Body Mass Index (BMI)",
      targetCalories: "Target calorie intake per day",
      macroBalance: "Macronutrient Balance",
      fats: "Fats",
      protein: "Protein",
      carbs: "Carbs",
      bodyFat: "Body Fat",
      fatMass: "Fat Mass",
      leanMass: "Lean Mass",
      disclaimer: "Educational content only. Not medical advice",
      inches: "inches",
    },
    activityRecs: {
      title: "Small Moves. Real Progress. Long-term results",
      subtitle: "You don't need to train like an athlete — you just need to stay consistent. Our medical team recommends simple, sustainable habits that match your lifestyle and support lasting results",
      rec1: "2 weekly sessions of resistance or strength training",
      rec2: "5,000–10,000 daily steps — your simplest form of cardio",
      rec3: "150–300 minutes of moderate movement each week",
      rec4: "75–150 minutes of higher-intensity activity if you enjoy pushing further",
      disclaimer: "Consultation required. Individual recommendations may vary",
    },
    faq: {
      label: "Q&A Weight Loss",
      intro: "Before starting your treatment, it's natural to have questions. Here's what patients ask most — and what our medical team wants you to know",
      q1: "What are physician-supervised weight loss therapies?",
      a1: "They are physician-supervised therapies now widely used as part of safe, medical weight management programs. They are designed to help support appetite awareness, metabolic balance, and overall wellness.",
      q2: "Are these medications safe?",
      a2: "They are safe when prescribed by a healthcare professional. Side effects may include nausea or digestive changes, which are managed through dose adjustments and medical support.",
      q3: "How much weight can I lose?",
      a3: "Some notice early improvements in appetite and energy within weeks, while visible weight changes usually appear after 4–8 weeks of consistent treatment.",
      q4: "Do I still need diet and exercise?",
      a4: "Yes, lifestyle changes enhance the results and help sustain them. Our coaching is designed to make this practical.",
      q5: "How soon will I see results?",
      a5: "Some notice early improvements in appetite and energy within weeks, while visible weight changes usually appear after 4–8 weeks of consistent treatment.",
    },
    finalCta: {
      headline: "If you're ready for a safe, supervised, and personalized way to reach your goals, not a quick fix, but a real medical plan that fits your everyday life,",
      headlineBold: "our Diverse Care Now team is ready to guide your next step.",
      tagline: "It's not just weight. It's your energy, your rhythm, your confidence.",
      body1: "Under the guidance of Diverse Care Now's medical team,",
      body2: "every plan begins with one purpose, helping you feel in control of your body again, with safety, science, and support in every step.",
      speakCta: "Speak with a provider and find out if medical weight loss therapy is right for you.",
      legalDisclaimer: "Our website and ads promote a physician-guided weight loss program. We do not sell or advertise prescription medications. All treatments are supervised by licensed medical providers as required by law.",
    },
    footer: {
      email: "patientcare{'@'}diversecarenow.com",
      phone1: "(754) 752-1888",
      phone2: "17542761746",
      bookAppointment: "Book an Appointment",
      termsOfUse: "Terms of Use",
      privacyPolicy: "Privacy Policy",
      copyright: "Copyright © 2026",
      companyName: "DIVERSE CARE NOW",
      allRights: "All Rights Reserved.",
      footerDisclaimer: "Consultation required. Prescriptions are issued at the discretion of the medical provider based on clinical necessity. Results may vary by individual.",
    },
    bitAssist: {
      call: "Call",
      sms: "SMS",
      whatsapp: "Whatsapp",
    },
  },
};
